var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';


import { Tip } from "../../Layout";
import { ToggleChildren } from "../../Settings/components/ToggleChildren";
import { Select } from "../../ReactReduxForms";
import { t } from "../../I18N";
import { loadPages as loadPagesAction } from "../../Pages/actions/pageActions";
import { updateValue as updateValueAction } from "../actions/templateActions";

const mapStateToProps = ({ pages }, ownProps) => ({
  pages: (pages === null || pages === void 0 ? void 0 : pages.filter((p) => p.get('entityView'))) || [],
  selectedPage: ownProps.selectedPage
});

const mapDispatchToProps = (dispatch) =>
bindActionCreators({ loadPages: loadPagesAction, updateValue: updateValueAction }, dispatch);

const connector = connect(mapStateToProps, mapDispatchToProps);



const TemplateAsPageControl = ({ pages, loadPages, selectedPage, updateValue }) => {
  useEffect(() => {
    loadPages();
  }, []);

  return /*#__PURE__*/(
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx("label", {}, void 0,
    pages.size > 0 ?
    t('System', 'Display entity view from page') :
    t('System', 'There are no pages enabled for entity view'), /*#__PURE__*/
    _jsx(Tip, { icon: "info-circle", position: "right" }, void 0,
    t(
      'System',
      'Entities can be displayed in a custom page. For that, a custom page needs to be created in Pages, and then selected here.'
    )
    )
    ),
    pages.size > 0 && /*#__PURE__*/
    _jsx(ToggleChildren, {
      toggled: Boolean(selectedPage),
      onToggleOff: () => updateValue('.entityViewPage', '') }, void 0, /*#__PURE__*/

    _jsx(Select, {
      model: ".entityViewPage",
      optionsValue: "sharedId",
      optionsLabel: "title",
      options: pages.toJS() }
    )
    )

    ));

};

const container = connector(TemplateAsPageControl);
export { container as TemplateAsPageControl };